<template lang="html">
    <data-table
        :headers="datatable.headers"
        :toolbar="datatable.toolbar"
        :actions="datatable.actions"
        :endpoint="datatable.endpoint"
        @rowClick="rowClick"
        storeId="comments"
        ref="list"
    >
        <template slot="items" slot-scope="props">
            <td class="text-xs-left author">
                <avatar :item="props.item" field="photo"></avatar>
                {{props.item.label}}
            </td>
            <td class="text-xs-right">
                {{props.item.label_2}}
            </td>
            <td class="text-xs-right">
                {{props.item.code}}
            </td>
            <td class="text-xs-right">
                {{props.item.ref_externe}}
            </td>
            <td class="text-xs-right">
                <template v-if="props.item.de_serie">
                    Oui
                </template>
                <template v-else>
                    Non
                </template>
            </td>
        </template>

    </data-table>
</template>

<script>
import DataTable from '../../../components/DataTable.vue'
import moment from 'moment'
import Avatar from '../../../components/avatar/Avatar.vue'

export default {
	components: { DataTable, Avatar },

	data() {
		return {
		    moment,
			datatable: {
				headers: [
					{ text: 'Désignation', sortable: true, value: 'label', align: 'left' },
					{ text: 'Désignation 2', sortable: true, value: 'label_2', align: 'right' },
					{ text: 'Code', sortable: true, value: 'code', align: 'right' },
					{ text: 'Ref externe', sortable: true, value: 'ref_externe', align: 'right' },
					{ text: 'De série', sortable: true, value: 'de_serie', align: 'right' },
				],
				endpoint: {
					base: '/api/products',
					filters: `parents.linked_product.product_id|=|${this.$route.params.id},group|=|accessory`,
				}
			},
            hide_demand : false
		}
	},
	methods: {
        rowClick(item){

        }
	},
	created() {
		this.$eventHub.$on('reload-list', () => {
			if (this.$refs.list) {
				this.$refs.list.reload()
			}
		})
	},
    mounted() {

    }
}
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/views/products/single/Accessories.vue